import { ActivityType } from '~/types';
import { activityEmojis } from '~/utils';
import Emoji from './Emoji';

const ActivityEmoji: React.FC<{ type: ActivityType }> = ({ type }) => (
  <Emoji v={ activityEmojis[type] } />
);

export default ActivityEmoji;
